import bowser from 'bowser';

export const SMALL = window.innerWidth <= 800;

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const getOS = () => {
  const parser = bowser.getParser(window.navigator.userAgent);
  const OS = parser.getOSName();
  // We prefer "Mac" to macOS
  return OS === 'macOS' ? 'Mac' : OS;
};
